import React from "react";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { FormattedMessage } from "react-intl";
import DraggableModal from "../../../common/DraggableModal";
import DraggableModalHead from "../../../common/DraggableModal/DraggableModalHead";
import DraggableModalBody from "../../../common/DraggableModal/DraggableModalBody";

const useStyles = makeStyles(theme => ({
  modal: {
    width: "500px",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  modalBody: {
    padding: "30px 20px 15px 20px",
    fontSize: 16,
    textAlign: "center",
  },
  modalFooter: {
    marginTop: 30,
    padding: "15px 0 0 0",
    borderTop: "1px solid #ddd",
  },
  btn: {
    padding: "3px 5px",
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.8,
    },
  },
  btnCancel: {
    textTransform: "none",
    color: theme.palette.common.link,
    marginRight: 5,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));

const DeleteModal = ({ open, handleClose, name, handleDelete }) => {
  const classes = useStyles();

  return (
    <DraggableModal
      open={open}
      handleClose={handleClose}
      customClass={classes.modal}
    >
      <DraggableModalHead
        handleClose={handleClose}
        title={<FormattedMessage id="product.delete" />}
      />
      <DraggableModalBody customClass={classes.modalBody}>
        <FormattedMessage id="context.deleteConfirmation" />{" "}
        <strong>{name}</strong>?
        <Box className={classes.modalFooter} align="right">
          <Button className={classes.btnCancel} onClick={() => handleClose()}>
            <FormattedMessage id="btn.cancel" />
          </Button>

          <Button className={classes.btn} onClick={() => handleDelete()}>
            <FormattedMessage id="btn.yes" />
          </Button>
        </Box>
      </DraggableModalBody>
    </DraggableModal>
  );
};

DeleteModal.defaultProps = {
  name: "",
};

DeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  name: PropTypes.string,
  id: PropTypes.string.isRequired,
};

export default DeleteModal;
